module.exports = __webpack_public_path__ + "static/media/Sun-15.40e637ed.png";